export const questions: Array<[string, string]> = [
  [
    'Per chi è questa collezione?',
    'Per insegnanti di scienze, tecnologia, geografia e materie affini della scuola secondaria e degli istituti tecnici che vogliono lezioni sull’industria mineraria più chiare e pronte all’uso.',
  ],
  ['In che formato ricevo il materiale?', 'In PDF scaricabili, da consultare su computer, tablet o da stampare.'],
  ['Quando ricevo l’accesso?', 'Subito dopo il pagamento ricevi via email il link di accesso.'],
  [
    'Serve una preparazione specifica in geologia o ingegneria mineraria?',
    'No, i contenuti partono dalle basi e arrivano ai temi più avanzati in modo progressivo.',
  ],
  [
    'Posso usarlo con i miei studenti?',
    'Sì, è pensato per l’uso in classe: attività, casi di studio, progetti e verifiche pronti.',
  ],
  ['C’è una garanzia?', 'Sì, hai 7 giorni di garanzia di soddisfazione.'],
];
